<div class="playarea">
  <app-players [firstScreen]="'playarea'"></app-players>
</div>
<div class="scoreboard">
 <h3>Scoreboard</h3>
 <app-players [firstScreen]="false"></app-players>
</div>



// WEBPACK FOOTER //
// C:/Users/BHAJ/Desktop/dribbler/src/app/playground/playground.component.html